import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Icon from '../buttons/Icon';
import VosBesoinsLoader from "./vosBesoinsLoader";
import StepHeadline from "../Titles/StepHeadline";
import BesoinList from "./besoinsList/besoinsList";
import BesoinItem from "./besoinsList/besoinItem";
import BesoinsDetails from "./besoinsDetails/besoinsDetails";
import LayoutStandardWidth from "../../layouts/LayoutStandardWidth";
import { TextArea, Button, Attachments } from "../Forms/Forms";
import fetchApiData from '../apiHandlers/fetchApiData';
import { headTitleTag } from '../../helpers/functions';
import { setServices, CurrentStepSetAction, selectedServices, setCommentServices } from '../../actions/action';
import CONSTANTS from '../../constants.js';
import { pushToGTMTracker } from '../../helpers/trackerManager';
import "./vosBesoins.css";
import AttachmentsFlex from '../Forms/AttachmentsFlex';


const mapStateToProps = state => state;
const mapDispatchToProps = { setServices, CurrentStepSetAction, selectedServices, setCommentServices };

class VosBesoins extends PureComponent {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            pageLoaded: false,
            serviceComment: props.store.commentServices,
            mobileShowServices: false,
            bannerShow : false,
            urlImage : '',
            urlToSend : '',
            showPopinAttachments:false,
            isErrorMessageArea : false,
        };
        this.showServices = this.showServices.bind(this);
        this.CheckAlreadyAdded = this.CheckAlreadyAdded.bind(this);
        this.tmtsInterventionIds = sessionStorage.getItem('tmtsInterventionIds')
    }

    componentWillMount() {
        this._isMounted = true;
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        pushToGTMTracker("services-page", window.siteConfig.v2prestations.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()));

        // this.props.CurrentStepSetAction(4);
        const listForfait = new fetchApiData();
        const data = { ...this.props.store };
        listForfait.getForfait({
            "brandCode": data.car.BrandCode,
            "cultureCode": CONSTANTS.SITE_INFO.CULTURE,
            "idDealer": data.dealer.iD,
            "serialNumber": data.car.SerialNumber,
            "modelCode": data.car.ModelCode,
            "motorCode": data.car.MotorCode,
            "lcdv": data.car.Lcdv,
            "energyLabel": data.car.EnergyLabel,
            "mileage": data.kilo.kilometrage,
            "registration": data.car.Registration,
            "serviceContract": data.kilo.contratService

        }).then(
            res => {
                if (this._isMounted) {
                    if (res.d.FamilyList.ErrorCode == 0)
                        this.setState({ pageLoaded: true });

                    this.props.setServices({ forfaits: res.d.FunctionList, families: res.d.FamilyList });

                    //verifier si tmtsInterventionIds est null
                    let tmtsPreSelectedServices = res.d.FamilyList.listeIntervention.filter(intervention => this.tmtsInterventionIds.indexOf(intervention.interventionId) > -1)
                    !this.props.store.SelectedServices.length && tmtsPreSelectedServices.forEach(item => this.showServices(item, true))

                    /**
                                                         	
                                            Reset forfait list with new forfait list gotted from API due to:
                                            - on carDetails.js its erased because the car is changed
                                            - Dealer is changed so forfait list on store should be erased and updated
                                                         	
                                         */


                    let updatedSelectedServices = JSON.parse(JSON.stringify(this.props.store.SelectedServices));
                    updatedSelectedServices = updatedSelectedServices.map((forfaitType, ftkey) => {
                        if (forfaitType.forfaits != null && !forfaitType.forfaits.length) {
                            const forfaitFamilyCode = forfaitType.codeFamilyForfait;
                            forfaitType.forfaits = [];
                            res.d.FunctionList.map((rawForfaitType, rftKey) => {
                                if (forfaitFamilyCode !== null && forfaitFamilyCode.indexOf(rawForfaitType.Code) > -1) {
                                    console.warn('forfait pushed', { ...rawForfaitType });
                                    forfaitType.forfaits.push(rawForfaitType);
                                }
                            });

                        }
                        return forfaitType;
                    });
                    this.props.selectedServices(updatedSelectedServices);

                    /* END */
                }

            },
            error => {
                console.warn(error);

                this.setState({ pageLoaded: true });
            }
        );
        listForfait.getBannerInfo().then(res => {
            this.setState({
                bannerShow : !!parseInt(res.d.InterventionShowPromotionalPopUp),
                urlImage : !!parseInt(res.d.InterventionShowPromotionalPopUp) && res.d.PromotionalPopUpImage,
                urlToSend : !!parseInt(res.d.InterventionShowPromotionalPopUp) && res.d.PromotionalPopUpLink,
            })
        })

    }
    showServices(selectedFamily, isTmtsPreSelection = false) {
        const selectedServices = Object.assign({}, this.props.store.SelectedServices);
        if (!this.CheckAlreadyAdded(selectedFamily.interventionId)) {
            const rawForfaits = Object.assign({}, this.props.store.service.forfaits);
            console.warn(rawForfaits);
            let familywithForfaits = [];
            familywithForfaits = Object.assign({}, selectedFamily);
            familywithForfaits['forfaits'] = Object.values(rawForfaits).filter(function (item) {
                if (selectedFamily.codeFamilyForfait !== null && selectedFamily.codeFamilyForfait.indexOf(item.Code) != -1)
                    return item;

            });
            this.props.selectedServices([...Object.values(selectedServices), familywithForfaits]);

        } else if (!isTmtsPreSelection) {
            const filtredServices = Object.values(selectedServices).filter(function (item) {
                if (item.interventionId != selectedFamily.interventionId)
                    return item;
            });
            this.props.selectedServices(filtredServices);
        }
    }
    CheckAlreadyAdded(id) {
        const selectedServices = Object.assign({}, this.props.store.SelectedServices);
        const filtredServices = Object.values(selectedServices).filter(function (item) {
            if (item.interventionId == id)
                return item;
        });
        return filtredServices.length > 0;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const SEO_TITLE = (window.siteConfig.v2prestations != undefined ? window.siteConfig.v2prestations.Title : '');
        const SEO_DESC = (window.siteConfig.v2prestations != undefined ? window.siteConfig.v2prestations.MetaDescription : '');

        const forfaitsFamilies = this.props.store.service.families;
        const selectedFiles = this.props.store.uploadedFile;
        const ifForfaitPricesActivated = !!parseInt(window.siteConfig['ActivateFFPrices']);

        const ActivateAttachmentTool = (!!parseInt(CONSTANTS.SITE_INFO.ACTIVATEATTACHMENTTOOL))
        return (
            <React.Fragment>
                {
                    headTitleTag(SEO_TITLE.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()),
                        SEO_DESC.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
                }
                <StepHeadline
                    Title={!this.state.mobileShowServices && CONSTANTS.LABELS.needs_title}
                    SubTitle={!this.state.mobileShowServices && CONSTANTS.LABELS.needs_subtitle1}
                />
                {CONSTANTS.SITE_INFO.BRAND_CODE !== "C" && 
                <LayoutStandardWidth classes="container-specific-width">
                    {this.state.pageLoaded && <React.Fragment>
                        {((window.isMobile() == 'desktop') || !this.state.mobileShowServices) &&
                        <div className="section-services-banniere">
                            <div className={this.state.bannerShow ? "services-banniere" : ""}>
                                <BesoinList>
                                    {forfaitsFamilies && forfaitsFamilies.listeIntervention.map(function (item, key) {
                                        const isShowed = item.Booking ;
                                        const isSelected = this.CheckAlreadyAdded(item.interventionId);
                                        return isShowed ? <BesoinItem title={item.interventionLabel}
                                            icon={item.Image}
                                            id={item.interventionId}
                                            key={`${item.interventionId}-${key}`}
                                            isChecked={isSelected}
                                            onClick={() => this.showServices(Object.assign({}, item))} /> : ''
                                    }.bind(this))}
                                </BesoinList>
                                {this.state.bannerShow && 
                                    this.state.urlToSend ? 
                                        <a href={this.state.urlToSend} target='_blank'><img src={this.state.urlImage} alt="" /></a>
                                    :
                                        <img src={this.state.urlImage} alt="" />
                                }
                            </div>
                            <p tabIndex="0" className='info-prestation' style={{ margin: 20 }} dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_complementaryinformation) }}></p>
                        </div>
                        }
                        {/* For Mobile = > show the button to active/desactivate the services list */}
                        {window.isMobile() != 'desktop' && !this.state.mobileShowServices &&

                            <Button
                                Disabled={this.props.store.SelectedServices.length < 1}
                                onClick={() => {
                                    this.setState({ mobileShowServices: true });
                                }}
                            >
                                {CONSTANTS.LABELS.common_v2_nextstep}
                            </Button>
                        }

                        {(window.isMobile() == 'desktop' || this.state.mobileShowServices) && <React.Fragment>
                            {
                                <h4 tabIndex="0" className="services-list-details__title section__title"
                                    onClick={(e) => this.setState({ mobileShowServices: false })}
                                >
                                    {window.isMobile() !== 'desktop' && <Icon Name={`arrowNavBold-reverse`} />}
                                    {window.isMobile() !== 'desktop' && ifForfaitPricesActivated && CONSTANTS.LABELS.needs_basket_label_mobileonly1}
                                    {window.isMobile() === 'desktop' && ifForfaitPricesActivated && CONSTANTS.LABELS.needs_basket_title}
                                </h4>
                            }
                            {ifForfaitPricesActivated && <BesoinsDetails />}

                            <div className={`services-list-comment__section ${!ActivateAttachmentTool ? 'full-width' : 'half-width'}`}>
                                <h4 tabIndex="0" className="services-list-comment__title section__title">{CONSTANTS.LABELS.needs_comment_label1}
                                    <span className="section__title-help"> {`(${this.state.serviceComment.length}/500 ${CONSTANTS.LABELS.summary_comment_label1})`} </span>
                                </h4>
                                <TextArea placeholder={CONSTANTS.LABELS.needs_comment_label2}
                                    classes="services-comment"
                                    maxLength={500}
                                    onChange={(e) => {
                                        if (
                                          e.target.value.match(
                                            /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                                          )
                                        )
                                          this.setState({
                                            isErrorMessageArea: true,
                                          })
                                        else
                                          this.setState({
                                            serviceComment: e.target.value,
                                            isErrorMessageArea: false,
                                          });
                                        }}
                                    value={this.state.serviceComment}
                                    iserror={this.state.isErrorMessageArea}
									labelerror={CONSTANTS.LABELS.userinfos_error_name_special_char}
                                />

                            </div>
                            {ActivateAttachmentTool &&
                                <div className="services-list-comment__section half-width">
                                    <h4 tabIndex="0" className="services-list-comment__title section__title">{CONSTANTS.LABELS.needs_attachment_title}
                                        {/* {CONSTANTS.LABELS.needs_attachments_label1} */}
                                        <span className="section__title-help" dangerouslySetInnerHTML={{__html: CONSTANTS.LABELS.needs_attachment_subtitle}} />
                                            
                                    </h4>
                                    <Attachments classes="services-attachments" />
                                </div>
                            }

                            <div className="services-list-button__section">
                                {(window.isMobile() == 'desktop' || this.state.mobileShowServices) &&
                                    <Button
                                        Disabled={this.props.store.SelectedServices.length < 1}
                                        linkTo={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                                        onClick={() => {
                                            this.props.selectedServices(this.props.store.SelectedServices);
                                            this.props.setCommentServices(this.state.serviceComment);
                                            this.props.CurrentStepSetAction(5);
                                        }}
                                    >         {CONSTANTS.LABELS.common_v2_nextstep}

                                    </Button>}
                            </div>


                        </React.Fragment>}

                    </React.Fragment>}
                    {!this.state.pageLoaded && <VosBesoinsLoader />}
                </LayoutStandardWidth>}

                {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
                    <div className="rootBesoinsCitroenContainer">
                    {this.state.pageLoaded && 
                        <React.Fragment>
                        {((window.isMobile() === 'desktop') || !this.state.mobileShowServices) &&
                        <div className="besoinListContainer">
                            <div className="section-services-banniere">
                            <div className={this.state.bannerShow ? "services-banniere" : ""}>
                                <BesoinList>
                                    {forfaitsFamilies && forfaitsFamilies.listeIntervention.map(function (item, key) {
                                        const isShowed = item.Booking ;
                                        const isSelected = this.CheckAlreadyAdded(item.interventionId);
                                        return isShowed ? <BesoinItem title={item.interventionLabel}
                                            icon={item.Image}
                                            id={item.interventionId}
                                            key={`${item.interventionId}-${key}`}
                                            isChecked={isSelected}
                                            onClick={() => this.showServices(Object.assign({}, item))} /> : ''
                                    }.bind(this))}
                                </BesoinList>
                                {this.state.bannerShow && 
                                    this.state.urlToSend ? 
                                        <a href={this.state.urlToSend} target='_blank'><img src={this.state.urlImage} alt="" /></a>
                                    :
                                        <img src={this.state.urlImage} alt="" />
                                }
                            </div>
                            <p tabIndex="0" className='info-prestation' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_complementaryinformation) }}></p>
                        </div>
                        </div>
                        
                        }
                        {/* For Mobile = > show the button to active/desactivate the services list */}
                        {window.isMobile() !== 'desktop' && !this.state.mobileShowServices &&

                            <Button
                                Disabled={this.props.store.SelectedServices.length < 1}
                                onClick={() => {
                                    this.setState({ mobileShowServices: true });
                                }}
                            >
                                {CONSTANTS.LABELS.common_v2_nextstep}
                            </Button>
                        }

                        {(window.isMobile() === 'desktop' || this.state.mobileShowServices) && 
                        <React.Fragment>
                            {
                                <h4 tabIndex="0" className="services-list-details__title section__title"
                                    onClick={(e) => this.setState({ mobileShowServices: false })}
                                >
                                    {window.isMobile() !== 'desktop' && <Icon Name={`arrowNavBold-reverse`} />}
                                    {window.isMobile() !== 'desktop' && ifForfaitPricesActivated && CONSTANTS.LABELS.needs_basket_label_mobileonly1}
                                    {window.isMobile() === 'desktop' && ifForfaitPricesActivated && CONSTANTS.LABELS.needs_basket_title}
                                </h4>
                            }
                            {ifForfaitPricesActivated && 
                                <div className="besoinDetailsContainer">
                                    <BesoinsDetails/>
                                </div> }
                            
                            <div className="commentAttachmentContainer">
                                <div className="commentContainer">
                                    <div 
                                    tabIndex="0"
                                    className="commentTitle"
                                    >
                                        {`${CONSTANTS.LABELS.needs_comment_label1} (${this.state.serviceComment.length}/500 ${CONSTANTS.LABELS.summary_comment_label1})`}
                                    </div>
                                    <TextArea 
                                        placeholder={CONSTANTS.LABELS.needs_comment_label2}
                                        maxLength={500}
                                        onChange={(e) => {
                                        if (
                                          e.target.value.match(
                                            /[^\p{L}\p{N}\p{M}\p{Sc}\s\.\?%!:,¿¡'"-]/gu
                                          )
                                        )
                                          this.setState({
                                            isErrorMessageArea: true,
                                          })
                                        else
                                          this.setState({
                                            serviceComment: e.target.value,
                                            isErrorMessageArea: false,
                                          });
                                        }}
                                        cols={"unset"}
                                        rows={"unset"}
                                        className="commentTextArea"
                                        value={this.state.serviceComment}
                                        iserror={this.state.isErrorMessageArea}
                                        labelerror={CONSTANTS.LABELS.userinfos_error_name_special_char}
                                    />
                                </div>

                                {ActivateAttachmentTool &&
                                <div className="attachmentRootContainer">
                                    <div tabIndex="0" className="attachmentContainerTitle">
                                        <div className="attachmentTitle">{CONSTANTS.LABELS.needs_attachment_title}</div>
                                        <div className="attachmentIconContainer">
                                            <div
                                            className={
                                                this.state.showPopinAttachments 
                                                    ? "attachmentIconInfo isClicked" 
                                                    :  "attachmentIconInfo"
                                                }
                                            name="info"
                                            tabIndex="0"
                                            onKeyDown={(e) => this.setState({showPopinAttachments : !this.state.showPopinAttachments})}
                                            onClick={(e) => this.setState({showPopinAttachments : !this.state.showPopinAttachments})}
                                            ></div>
                                            
                                            {this.state.showPopinAttachments && 
                                            <div className="attachmentPopup">
                                                <div dangerouslySetInnerHTML={{__html: CONSTANTS.LABELS.needs_attachment_subtitle}}></div>
                                            </div>}
                                        </div>
                                        
                                    </div>
                                    
                                    <AttachmentsFlex classes="services-attachments" />
                                </div>
                                }
                            </div>

                            <div className="nextStepButtonContainer">
                                {(window.isMobile() === 'desktop' || this.state.mobileShowServices) &&
                                    <Button
                                        Disabled={this.props.store.SelectedServices.length < 1}
                                        linkTo={CONSTANTS.SITE_ROUTS.PERSONNALDETAILSPAGE}
                                        onClick={() => {
                                            this.props.selectedServices(this.props.store.SelectedServices);
                                            this.props.setCommentServices(this.state.serviceComment);
                                            this.props.CurrentStepSetAction(5);
                                        }}
                                    >         {CONSTANTS.LABELS.common_v2_nextstep}

                                    </Button>}
                            </div>


                        </React.Fragment>}

                    </React.Fragment>}
                    {!this.state.pageLoaded && <VosBesoinsLoader />}
                </div>}
            </React.Fragment>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(VosBesoins);